module.exports = {"511133100":"民建镇","511133101":"荣丁镇","511133102":"下溪镇","511133103":"苏坝镇","511133104":"烟峰镇","511133105":"劳动镇","511133106":"荍坝镇","511133107":"建设镇","511133108":"民主镇","511133109":"梅林镇","511133110":"雪口山镇","511133111":"三河口镇","511133211":"大竹堡乡","511133223":"高卓营乡","511133226":"永红乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511133.json
// module id = 2469
// module chunks = 0